<template>
    <div role="rowgroup">
        <input-row label="이름" pointer>
            <input-item v-model="applicant.name" @input="sync" />
        </input-row>
        <input-row label="학교/학과" pointer>
            <div class="row row--small">
                <div class="col-12 col-md-6">
                    <input-item v-model="applicant.affiliation" @input="sync" />
                </div>
                <div class="col-12 col-md-6">
                    <input-item v-model="applicant.department" @input="sync" />
                </div>
            </div>
        </input-row>
        <input-row label="생년월일" pointer>
            <div class="form-birth">
                <input-birth mode="년" v-model="applicant.bornY" @input="sync" />
                <input-birth mode="월" v-model="applicant.bornM" @input="sync" />
                <input-birth mode="일" v-model="applicant.bornD" :year="applicant.bornY" :month="applicant.bornM" @input="sync" />
            </div>
        </input-row>
        <input-row label="연락처" pointer>
            <div class="form-tel">
                <input class="input" v-model="applicant.phone1" type="tel" name="phone1" maxlength="4" @input="sync" />
                <span class="text"></span>
                <input class="input" v-model="applicant.phone2" type="tel" name="phone2" maxlength="4" @input="sync" />
                <span class="text"></span>
                <input class="input" v-model="applicant.phone3" type="tel" name="phone3" maxlength="4" @input="sync" />
            </div>
        </input-row>
        <input-row label="이메일" pointer>
            <input-email v-model="applicant" @input="sync" />
        </input-row>
    </div>
</template>

<script>
import InputRow from "@/components/client/dumb/input-row.vue";
import InputItem from "@/components/client/dumb/input-item.vue";
import InputBirth from "@/components/client/dumb/input-birth.vue";
import InputEmail from "@/components/client/dumb/input-email.vue";
export default {
    components: {
        InputRow,
        InputItem,
        InputBirth,
        InputEmail,
    },
    props: ["value", "program", "files"],
    computed: {
        bornAt() {
            const { bornY, bornM, bornD } = this.applicant;
            return `${bornY}-${bornM}-${bornD}`;
        },
        phone() {
            const { phone1, phone2, phone3 } = this.applicant;

            return `${phone1}-${phone2}-${phone3}`;
        },
        email() {
            const { email1, email2 } = this.applicant;

            return `${email1}@${email2}`;
        },
        computedApplication() {
            const { bornAt, phone, email } = this;
            return { ...this.applicant, bornAt, email, phone };
        },
        programTitle() {
            return this.program?.title;
        },
    },
    data() {
        return {
            applicant: {},
        };
    },
    methods: {
        init() {
            const { bornAt, phone, email } = this.value;

            const [phone1, phone2, phone3] = phone?.split("-");
            const [email1, email2] = email?.split("@");
            const [bornY, bornM, bornD] = bornAt.toDate().split("-");

            this.applicant = {
                ...this.value,
                bornY,
                bornM,
                bornD,
                phone1,
                phone2,
                phone3,
                email1,
                email2,
            };
        },
        sync() {
            this.$emit("input", this.computedApplication);
        },
    },
    watch: {
        value() {
            if (this.value) this.init();
        },
    },
    mounted() {
        if (this.value) this.init();
    },
};
</script>

<style></style>
